import { post as $post } from './core/fetch';

export const account_identity = mono_user_id => $post('/account-identify', { mono_user_id });
